import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { getAuth, signOut, onIdTokenChanged } from 'firebase/auth';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

export default function Navbar() {
  const navigate = useNavigate();
  const auth = React.useMemo(() => getAuth(), []);
  const [hasAdminClaim, setHasAdminClaim] = React.useState(false);
  const [claimsChecked, setClaimsChecked] = React.useState(false);
  const [userEmail, setUserEmail] = React.useState('');
  const [isSystemAdmin, setIsSystemAdmin] = React.useState(false);

  React.useEffect(() => {
    let isActive = true;
    const unsub = onIdTokenChanged(auth, async (user) => {
      if (!isActive) {
        return;
      }
      if (!user) {
        setHasAdminClaim(false);
        setUserEmail('');
        setIsSystemAdmin(false);
        setClaimsChecked(true);
        return;
      }
      setUserEmail(user.email || '');
      try {
        const tokenResult = await user.getIdTokenResult();
        if (!isActive) {
          return;
        }
        setHasAdminClaim(!!tokenResult?.claims?.admin);
        setIsSystemAdmin(tokenResult?.claims?.role === 'SYSTEM_ADMIN');
      } catch (err) {
        console.warn('Failed to inspect ID token claims', err);
        if (isActive) {
          setHasAdminClaim(false);
        }
      } finally {
        if (isActive) {
          setClaimsChecked(true);
        }
      }
    });
    return () => {
      isActive = false;
      if (typeof unsub === 'function') {
        unsub();
      }
    };
  }, [auth]);

  const handleSignOut = async () => {
    await signOut(auth);
    navigate('/login');
  };
  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" component="div">Maritaca Admin</Typography>
        <Box sx={{ ml: 3 }}>
          <Button color="inherit" component={RouterLink} to="/">Dashboard</Button>
          <Button color="inherit" component={RouterLink} to="/participants">Participants</Button>
          <Button color="inherit" component={RouterLink} to="/rooms">Rooms</Button>
          <Button color="inherit" component={RouterLink} to="/devices">Devices</Button>
          {isSystemAdmin && (
            <>
              <Button color="inherit" component={RouterLink} to="/domains">Domains</Button>
              <Button color="inherit" component={RouterLink} to="/admins">Admins</Button>
            </>
          )}
        </Box>
        <Box sx={{ flex: 1 }} />
        {userEmail && (
          <Typography variant="body2" sx={{ mr: 2 }}>{userEmail}</Typography>
        )}
        {claimsChecked && hasAdminClaim && (
          <Chip label="Admin" color="secondary" size="small" sx={{ mr: 2 }} />
        )}
        <Button color="inherit" onClick={handleSignOut}>Sign out</Button>
      </Toolbar>
    </AppBar>
  );
}
